<div [dglSpinner]="value" class="spinner-layout dglSpinner"></div>
